module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0005.jpg?v=561d6b0f";